import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LanguageEs } from './es/language_es';
import { LanguageEn } from './en/language_en';
import { LanguageVi } from './vi/language_vi';

// Clase para la traducción a español.
@Injectable()
export class Translation {

    actualLanguage: string;

    vocabulary: {};
    vocabulary$ = new Subject<{}>();


 constructor() {
    this.actualLanguage = localStorage.getItem('lang');

    // console.log('--> Idioma seleccionado:')
    // console.log(this.actualLanguage);

    this.changeLanguage(this.actualLanguage);
 } // End function constructor


 changeLanguage(langIn: string) {
    // console.log(' ->-> Cambiando a idioma: ');
    this.actualLanguage = langIn;

    switch (langIn) {
        case 'es':
            console.log('--> Idioma Español:')
            this.vocabulary$.next(new LanguageEs().vocabulary);
            this.vocabulary = new LanguageEs().vocabulary;
            break;

        case 'en':
            console.log('--> Idioma Inglés:')
            this.vocabulary$.next(new LanguageEn().vocabulary);
            this.vocabulary = new LanguageEn().vocabulary;
            break;
        
        case 'vi':
            console.log('--> Skin Vinos:')
            this.vocabulary$.next(new LanguageVi().vocabulary);
            this.vocabulary = new LanguageVi().vocabulary;
            break;

        // Español lenguaje por defecto.
        default:
            this.actualLanguage = 'es';
            console.log('--> Idioma por defecto:')
            this.vocabulary$.next(new LanguageEs().vocabulary);
            this.vocabulary = new LanguageEs().vocabulary;
            break;
    }

    // console.log('--> Idioma Vocabulario:')
    // console.log(this.vocabulary);

 } // End function changeLanguage

 getVocabulary$(): Observable<{}> {
    return this.vocabulary$.asObservable();
 }

} // End class Translation